import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import uploadImagetow from '@/components/uploadImagetow';
import addEmperor from "./components/add.vue";
import { banedUserList, banUser, serverList } from "@/api/gmtool/packageCode";
import { gmTool } from "@/mixins/index";
export default {
  name: "emperor",
  components: {
    addEmperor: addEmperor,
    uploadImagetow: uploadImagetow
  },
  mixins: [gmTool],
  data: function data() {
    return {
      advanced: false,
      currentPage: 1,
      tableData: [],
      // 表格数据
      tableCopyTableList: [],
      // 表格copy数据b
      value1: '',
      paramsData: {
        op_kind: 1
      },
      listB: [],
      sels: []
    };
  },
  created: function created() {// this.getList()
  },
  activated: function activated() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getList();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getList: function getList() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.reqLoading = true;
                banedUserList(_this2.paramsData).then(function (res) {
                  if (res.status == 200) {
                    _this2.tableData = res.data;
                  }
                }).finally(function () {
                  _this2.reqLoading = false;
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.sels = val;
    },
    Renewal: function Renewal() {
      this.getList();
    },
    unseal: function unseal(data) {
      var _this3 = this;

      this.$prompt(this.$t('pleaseInputUnbanReason'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel')
      }).then(function (_ref) {
        var value = _ref.value;
        var d = {
          op_type: 0,
          uids: [],
          reason: value || '1'
        };
        data.forEach(function (item) {
          d.uids.push({
            uids: parseInt(item.accid)
          });
        });
        banUser(_objectSpread(_objectSpread({}, d), _this3.paramsData)).then(function (res) {
          if (res.status == 200) {
            _this3.$message({
              message: _this3.$t('unbanSuccess'),
              type: 'success'
            });

            _this3.getList();
          }
        });
      });
    }
  }
};